export const SETTINGS_MOCK = [
    {
        "id": 1,
        "name": "company",
        "label": "Company",
        "value": "Retisio Inc."
    },
    {
        "id": 2,
        "name": "pdf_footer_note",
        "label": "PDF Footer Note",
        "value": "THANK YOU FOR YOUR BUSINESS!"
    }
]

export const SETTINGS_USER_MOCK = {
    fullName: 'Customer Name',
    email: 'customer@test.com',
}

export const SETTINGS_FIELDS = [
    { name: 'name', label: 'Name', rules: [{ required: true, message: 'Please enter the Name' }] },
    { name: 'label', label: 'Label', rules: [{ required: true, message: 'Please enter the Product' }] },
    { name: 'value', label: 'Value', rules: [{ required: true, message: 'Please enter the Value' }] },
];

export const INVOICE_CONFIG_FIELDS = [
    { name: 'description', label: 'Name', rules: [{ required: true, message: 'Please enter the Description' }] },
    { name: 'name', label: 'Key', rules: [{ required: true, message: 'Please enter the Name' }] },
    { name: 'value', label: 'Value', rules: [{ required: true, message: 'Please enter the Value' }] },
];

export const MODULES_FIELDS = [
    { name: 'name', label: 'Name', rules: [{ required: true, message: 'Please enter the Name' }] },
    { name: 'description', label: 'Description', rules: [] },
];

export const AVALARA_FIELDS = [
    { name: 'environment', label: 'Environment', rules: [{ required: true, message: 'Please enter the Environment!' }] },
    { name: 'endpoint', label: 'Avalara API Endpoint', rules: [
        { required: true, message: 'Please enter the Avalara API Endpoint!' },
    ]},
    { name: 'username', label: 'Avalara Username', rules: [
        { required: true, message: 'Please enter the username!' },
        { type: 'email', message: 'Please enter a valid username (Email)' },
    ]},
    { name: 'password', label: 'Avalara Password', rules: [
        { required: true, message: 'Please enter the password!' },
        { type: 'password' },
    ]},
    { name: 'company_code', label: 'Company Code', rules: [{ required: true, message: 'Please enter the Company code!' }] },
];

export const DEFAULT_SERVER_STATUS = { success: false, code: null, message: null };
